module.exports = __webpack_public_path__ + "static/media/readinglog.d414cd68.png";